 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		79: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "legacy-" + {"0":"4f506d8","1":"190afeb","2":"acd3316","3":"845d11d","4":"3acff3d","5":"042a56b","6":"ac7847f","7":"353bc45","8":"37399b3","9":"3ed2f9a","11":"a74c328","12":"51c41c6","13":"b943509","14":"d3b1b48","16":"d3208c9","17":"c6ffee4","18":"76afd62","19":"1631fb9","20":"2415490","21":"e4f51cd","22":"4264478","23":"22a13ce","24":"b2ac974","25":"45af57c","26":"131b31c","27":"0cbeab5","28":"d8d619c","29":"7bd20e0","30":"ee4a4c6","31":"8a68d39","32":"473cfa7","33":"5d28255","34":"ff8b0d9","35":"8a67424","36":"736daee","37":"fd9ec2f","38":"4a4a386","39":"3b816d0","40":"7276a02","41":"0b306a8","42":"30adc4f","43":"fa290b6","44":"c1668ad","45":"90e69d5","46":"4afeffb","47":"c4eee84","48":"65b10dd","49":"92e5341","50":"11cb8ec","51":"12b60a3","52":"d164c94","53":"2d7a916","54":"8d65442","55":"02919db","56":"95b7c75","57":"e209f40","58":"ad15084","59":"db20766","60":"b273b44","61":"984c708","62":"320e8e3","63":"d0d8d89","64":"8ed3d74","65":"7714e2b","66":"f56cd95","67":"e610e1a","68":"a8ff024","69":"e45d47b","70":"529b6a9","71":"c391d23","72":"2ae3534","73":"c3cd599","74":"c36ff2d","75":"939f0c4","76":"5d7257b","77":"f801f65","78":"f185f65","80":"79c6bed","81":"458c2df","82":"5629e88","83":"c30063c","85":"6bbf189","86":"f15696d","87":"62d402b","88":"01293e8"}[chunkId] + "-" + ({"0":"pages/__pages/_slug/p/_case_device_pages/c/_uuid_pages/capinhas-para-celular/_slug_pages/cart/index__83c227f8","1":"pages/__pages/_slug/p/_case_device_pages/c/_uuid_pages/capinhas-para-celular/_slug_pages/cart/index__8e47ba5b","2":"vendors_pages/__pages/_slug/p/_case_device_pages/black-friday_pages/capinhas-para-celular/_slug_page_cf13aa03","3":"pages/__pages/_slug/p/_case_device_pages/capinhas-para-celular/_slug_pages/cart/index_pages/copolife_1d49570b","4":"auth-box_pages/account/edit/index_pages/login_pages/signup/index_pages/user/spree_user/password/edit/index","5":"pages/c/_uuid_pages/kits/_kit/index_pages/update-order-items/_number_pages/update-order-items/editab_7dec9da6","6":"pages/c/_uuid_pages/kits/_kit/index_pages/update-order-items/_number","7":"auth-box","8":"footer","9":"pages/addresses/_address_id/edit/index_pages/addresses/new/index","11":"brand-device-selector","12":"brand-icons","13":"catalog-modal","14":"clutch-specifications","16":"commons_gallery-component","17":"custom-engine-input","18":"drawer-menu","19":"global-device-selector","20":"go-for-good-tabs","21":"grouped-products","22":"hero-banner","23":"home-widget","24":"license-banners","25":"middle-modal","26":"pages/_","27":"pages/_slug/p/_case_device","28":"pages/account/edit/index","29":"pages/account/index","30":"pages/addresses/_address_id/edit/index","31":"pages/addresses/index","32":"pages/addresses/new/index","33":"pages/admin","34":"pages/black-friday","35":"pages/c/_uuid","36":"pages/capinhas-para-celular/_slug","37":"pages/cart/index","38":"pages/category-filters/_slug","39":"pages/central-de-ajuda","40":"pages/collections/_slug","41":"pages/complete-registration/index","42":"pages/contact-us","43":"pages/copolife","44":"pages/finalized-order","45":"pages/find-order/index","46":"pages/go-for-good/index","47":"pages/iphone15","48":"pages/iphone16","49":"pages/kits/_kit/index","50":"pages/kits/index","51":"pages/landing-gifts/index","52":"pages/login","53":"pages/onde-encontrar/index","54":"pages/orders/_number/index","55":"pages/orders/_number/tracking/_track_number","56":"pages/orders/index","57":"pages/protocols/_number/index","58":"pages/protocols/index","59":"pages/redirect-by-device","60":"pages/review-request-high-rating","61":"pages/reviews","62":"pages/rewards/index","63":"pages/samsungs24","64":"pages/search/index","65":"pages/shopinsta/index","66":"pages/signup/index","67":"pages/smartphone-cases/_slug","68":"pages/t/_","69":"pages/totem-congratulations/index","70":"pages/update-order-items/_number","71":"pages/update-order-items/editable-line-item/EditableLineItem","72":"pages/update-order-items/editable-line-item/editable-line-item-form/EditableLineItemForm","73":"pages/user/spree_user/password/edit/index","74":"pages/user/spree_user/password/new/index","75":"pages/wishlist/index","76":"picture-input","77":"product-info-sections","78":"referralWidget","80":"spree-page","81":"stamped-io-feed","82":"stampedio","83":"stock-alert","85":"vendors_gallery-component","86":"vendors_picture-input","87":"vendors_sentry"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.gocase.com.br/.nuxt/dist/client/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
